function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _excluded = ["alignRight", "buttonIcon", "buttonKind", "buttonAriaLabel", "className", "defaultText", "description", "disabled", "dropdownKind", "dropUp", "dynamicDropAlign", "dynamicDropDirection", "error", "fieldID", "iconNameClose", "iconNameOpen", "inlineLabel", "label", "labelWidth", "panelHeight", "panelWidth", "required", "optional", "searchable", "size", "virtualScroll", "defaultPageSize", "removeMarginTop", "onChange"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { Waypoint } from 'react-waypoint';
import Button from '../Button';
import DropdownItem from './DropdownItem';
import DropdownGroup from './DropdownGroup';
import DropdownPanel from './DropdownPanel';
import DropdownField from './DropdownField';
import ClickListener from '../utils/ClickListener';
import KeyListener from '../utils/KeyListener';
import { getValidElementProps } from '../utils/htmlValidProps';
import { showWaypoint, showWaypointUp } from '../utils/waypointHelpers';
var ENTER_KEY = 13;
var SPACE_BAR_KEY = 32;
var focusableItemRoles = '[role="option"],[role="menuitem"]';

var WebDropdown = /*#__PURE__*/function (_PureComponent) {
  _inherits(WebDropdown, _PureComponent);

  var _super = _createSuper(WebDropdown);

  function WebDropdown(props) {
    var _this;

    _classCallCheck(this, WebDropdown);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "selectItemFromProps", function () {
      var children = _this.props.children;
      var selectedItemNode = null;
      React.Children.forEach(children, function (child, index) {
        if (child.props.groupName) {
          selectedItemNode = selectedItemNode || _this.findGroupedItemValueMatch(child, index);
        } else {
          selectedItemNode = selectedItemNode || _this.findItemValueMatch(child, index);
        }
      });
      return selectedItemNode;
    });

    _defineProperty(_assertThisInitialized(_this), "onUpArrow", function (e) {
      var _this$state = _this.state,
          focusedItemIndex = _this$state.focusedItemIndex,
          open = _this$state.open;

      if (open) {
        e.preventDefault();
        var count = _this.focusableItems.length;
        var calcFocusedItemIndex = (focusedItemIndex || 0) > 0 ? focusedItemIndex - 1 : count - 1;

        _this.setState({
          focusedItemIndex: calcFocusedItemIndex
        });

        _this.iterateDropdownFocus(calcFocusedItemIndex);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDownArrow", function (e) {
      var _this$state2 = _this.state,
          focusedItemIndex = _this$state2.focusedItemIndex,
          open = _this$state2.open;

      if (open) {
        e.preventDefault();
        var count = _this.focusableItems.length;
        var calcFocusedItemIndex = (focusedItemIndex || 0) < count - 1 ? focusedItemIndex + 1 : 0;

        _this.setState({
          focusedItemIndex: calcFocusedItemIndex
        });

        _this.iterateDropdownFocus(calcFocusedItemIndex);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSearchType", function (e) {
      var onChange = _this.props.onChange;

      _this.setState({
        searchedText: {
          value: e.target.value,
          show: true
        }
      });

      _this.focusableItems = _this.dropdown.querySelectorAll(focusableItemRoles);
      onChange && onChange(e);
    });

    _defineProperty(_assertThisInitialized(_this), "findGroupedItemValueMatch", function (group, groupIndex) {
      var children = _this.props.children;
      var itemGroups = children;
      var groupItemIndex = 0;

      for (var prevGroupCount = groupIndex; prevGroupCount > 0; prevGroupCount -= 1) {
        groupItemIndex += itemGroups[prevGroupCount - 1].props.children ? itemGroups[prevGroupCount - 1].props.children.length : 0;
      }

      var matchedItem = null;

      if (group.props.children) {
        if (Array.isArray(group.props.children)) {
          group.props.children.forEach(function (item, indx) {
            matchedItem = matchedItem || _this.findItemValueMatch(item, groupItemIndex + indx);
          });
        } else {
          matchedItem = matchedItem || _this.findItemValueMatch(group.props.children, groupItemIndex);
        }
      }

      return matchedItem;
    });

    _defineProperty(_assertThisInitialized(_this), "findItemValueMatch", function (item, itemIndex) {
      var matchedItem = null;
      var value = _this.props.value;

      if (item.props.value === value) {
        matchedItem = _objectSpread(_objectSpread({}, item), {}, {
          index: itemIndex
        });
      }

      return matchedItem;
    });

    _defineProperty(_assertThisInitialized(_this), "iterateDropdownFocus", function (focusIndex) {
      var focusedItemIndex = _this.state.focusedItemIndex;

      if (focusIndex || focusIndex === 0) {
        _this.setState({
          focusedItemIndex: focusIndex
        });

        if (_this.focusableItems[focusIndex]) {
          _this.focusableItems[focusIndex].focus();
        }
      } else {
        var count = _this.focusableItems.length;

        if (focusedItemIndex >= 0 && focusedItemIndex < count) {
          if (_this.focusableItems[focusedItemIndex]) {
            _this.focusableItems[focusedItemIndex].focus();
          }
        } else {
          _this.focusableItems[0].focus();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      var focusedItemIndex = _this.state.focusedItemIndex;

      _this.setState({
        open: false
      });

      if (focusedItemIndex !== -1) {
        _this.setState(function (prevState) {
          return {
            focusedItemIndex: prevState.selectedItemIndex,
            searchedText: {
              value: '',
              show: false
            }
          };
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggle", function (evt) {
      var disabled = _this.props.disabled;
      var open = _this.state.open;

      if (disabled) {
        return;
      }

      if (evt && (evt.type === 'click' || evt.key === 'Enter' || evt.which === SPACE_BAR_KEY)) {
        evt.preventDefault();

        _this.setState({
          open: !open
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleItemSelected", function (info, e) {
      var _this$props = _this.props,
          dropdownKind = _this$props.dropdownKind,
          onChange = _this$props.onChange;

      if (e.which === ENTER_KEY) {
        /* TDA-9727 Explains bad IE Enter+onClick behavior */
        e.preventDefault();
      }

      onChange(info);

      _this.setState({
        open: false,
        selectedItemIndex: dropdownKind === 'menu' ? 0 : info.index,
        selectedItemText: info.itemText,
        selectedItemValue: info.value,
        focusedItemIndex: info.index,
        searchedText: {
          value: '',
          show: false
        },
        selectedItemIconName: info.iconName,
        iconType: info.iconType
      }, _this.returnFocus);
    });

    _defineProperty(_assertThisInitialized(_this), "returnFocus", function () {
      var _this$props2 = _this.props,
          dropdownKind = _this$props2.dropdownKind,
          searchable = _this$props2.searchable;

      if (dropdownKind === 'menu') {
        _this.dropdown.querySelector('button').focus();
      } else {
        if (!searchable) {
          _this.dropdown.querySelector('.input__field').focus();
        }

        _this.close();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "buildDropdownGroup", function (group, index) {
      var _this$props3 = _this.props,
          children = _this$props3.children,
          dropdownKind = _this$props3.dropdownKind,
          searchable = _this$props3.searchable,
          customSearchFilter = _this$props3.customSearchFilter;
      var searchedText = _this.state.searchedText;
      var key = "listgroup-".concat(index);
      var groupItemIndex = 0;
      var showGroup = true;

      for (var prevGroupCount = index; prevGroupCount > 0; prevGroupCount -= 1) {
        groupItemIndex += children[prevGroupCount - 1].props.children ? children[prevGroupCount - 1].props.children.length : 0;
      }

      if (dropdownKind === 'select' && searchable && searchedText !== '' && Array.isArray(group.props.children)) {
        showGroup = false;

        for (var i = 0; i < group.props.children.length; i++) {
          if (customSearchFilter(group.props.children[i].props.itemText, searchedText.value)) {
            showGroup = true;
            break;
          }
        }
      }

      var buildDropdownGroupItems = function buildDropdownGroupItems() {
        if (group.props.children == null) {
          return null;
        }

        if (Array.isArray(group.props.children)) {
          return group.props.children.map(function (item, indx) {
            if (dropdownKind === 'select') {
              if (searchable && searchedText !== '' && !customSearchFilter(item.props.itemText, searchedText.value)) {
                return null;
              }

              return _this.buildDropdownItem(item, groupItemIndex + indx);
            }

            return _this.buildMenuItem(item, groupItemIndex + indx);
          });
        }

        if (dropdownKind === 'select') {
          return _this.buildDropdownItem(group.props.children, groupItemIndex);
        }

        return _this.buildMenuItem(group.props.children, groupItemIndex);
      };

      return showGroup && /*#__PURE__*/React.createElement(DropdownGroup, _extends({}, group.props, {
        role: "group",
        key: key,
        dropdownKind: dropdownKind,
        onChildClick: _this.handleItemSelected,
        groupIndex: index
      }), buildDropdownGroupItems());
    });

    _defineProperty(_assertThisInitialized(_this), "buildDropdownItem", function (child, index) {
      var _this$props4 = _this.props,
          dropdownKind = _this$props4.dropdownKind,
          fieldID = _this$props4.fieldID;
      var selectedItemValue = _this.state.selectedItemValue;
      var key = "".concat(fieldID, "-listitem-").concat(index);
      var dropdownItemClassName = classNames(_defineProperty({
        'dropdown__item--selected': selectedItemValue === child.props.value && dropdownKind !== 'menu'
      }, child.props.className, child.props.className));
      return /*#__PURE__*/React.createElement(DropdownItem, _extends({}, child.props, {
        key: key,
        dropdownKind: "select",
        onClick: _this.handleItemSelected,
        onKeyPress: _this.handleItemSelected,
        index: index,
        id: key,
        "aria-selected": selectedItemValue === child.props.value ? 'true' : 'false',
        className: dropdownItemClassName,
        fieldID: fieldID
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "buildMenuItem", function (child, index) {
      var fieldID = _this.props.fieldID;
      var key = "".concat(fieldID, "-listitem-").concat(index);
      return /*#__PURE__*/React.createElement(DropdownItem, _extends({}, child.props, {
        key: key,
        dropdownKind: "menu",
        onClick: function onClick(info, e) {
          child.props.onClick();

          _this.handleItemSelected(info, e);
        },
        onKeyPress: function onKeyPress(info, e) {
          child.props.onClick();

          _this.handleItemSelected(info, e);
        },
        index: index
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "dropdownPanelFocus", function () {
      _this.setState(function (prevState) {
        return {
          open: true,
          searchedText: _objectSpread(_objectSpread({}, prevState.searchedText), {}, {
            show: true
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      var disabled = _this.props.disabled;
      e && e.stopPropagation();

      if (!disabled) {
        _this.toggle(e); // Dropdown searchable needs to refocus the DropdownPanel when the Input is clicked to avoid open-close on first click


        if (e && e.target.tagName.toUpperCase() === 'INPUT') {
          _this.dropdownPanelFocus();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      var open = _this.state.open;

      if (open) {
        if (e.key === 'ArrowDown' && e.target.tagName.toUpperCase() === 'INPUT') {
          _this.onDownArrow(e);
        } else if (e.key === 'ArrowUp') {
          _this.onUpArrow(e);
        }
      } else {
        _this.open();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "open", function () {
      _this.setState({
        open: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "dropdownPanelBlur", function () {
      _this.setState(function (prevState) {
        return {
          searchedText: _objectSpread(_objectSpread({}, prevState.searchedText), {}, {
            show: false
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleLoadData", function (event) {
      if (!event) {
        return;
      }

      var _this$props5 = _this.props,
          children = _this$props5.children,
          defaultPageSize = _this$props5.defaultPageSize;
      var virtualStart = _this.state.virtualStart;

      if (virtualStart < children.length - 1) {
        var scrollPxAmount = (defaultPageSize + 1) * _this.getRowHeightNum();

        _this.setState({
          virtualStart: virtualStart + defaultPageSize
        }, _this.scroll.bind(_assertThisInitialized(_this), scrollPxAmount));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleLoadDataUp", function (event) {
      if (!event) {
        return;
      }

      var defaultPageSize = _this.props.defaultPageSize;
      var virtualStart = _this.state.virtualStart;

      if (virtualStart > defaultPageSize) {
        virtualStart -= defaultPageSize;
      } else {
        virtualStart = 0;
      }

      var scrollPxAmount = null;

      if (virtualStart === 0) {
        scrollPxAmount = 0;
      } else if (_this.dropdownPanelRef) {
        scrollPxAmount = (defaultPageSize + 1) * _this.getRowHeightNum();
      } // Set new virtualStart, then scroll to bottom so scroll is uninterrupted
      // Scroll to bottom so we can continue scrolling up without interruption


      _this.setState({
        virtualStart: virtualStart
      }, _this.scroll.bind(_assertThisInitialized(_this), scrollPxAmount));
    });

    _defineProperty(_assertThisInitialized(_this), "scroll", function (amount) {
      if (amount && _this.dropdownPanelRef) {
        _this.dropdownPanelRef.current.scrollTop = amount;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getRowHeightNum", function () {
      var size = _this.props.size;

      switch (size) {
        case 'small':
          return 32;

        case 'medium':
          return 40;

        case 'large':
          return 48;

        default:
          return 40;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getCalcChildren", function () {
      var _this$props6 = _this.props,
          children = _this$props6.children,
          dropdownKind = _this$props6.dropdownKind,
          searchable = _this$props6.searchable,
          customSearchFilter = _this$props6.customSearchFilter;
      var searchedText = _this.state.searchedText;
      return React.Children.map(children, function (child, index) {
        var newChild;

        if (child.props.groupName) {
          newChild = _this.buildDropdownGroup(child, index);
        } else if (dropdownKind === 'select' && searchable && customSearchFilter(child.props.itemText, searchedText.value)) {
          newChild = _this.buildDropdownItem(child, index);
        } else if (dropdownKind === 'select' && searchable) {
          return newChild;
        } else if (dropdownKind === 'select') {
          newChild = _this.buildDropdownItem(child, index);
        } else {
          newChild = _this.buildMenuItem(child, index);
        }

        return newChild;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getActualChildren", function (calcChildren) {
      var _this$props7 = _this.props,
          defaultPageSize = _this$props7.defaultPageSize,
          value = _this$props7.value;
      var _this$state3 = _this.state,
          open = _this$state3.open,
          virtualStart = _this$state3.virtualStart;

      if (calcChildren.length < virtualStart) {
        _this.setState({
          virtualStart: 0
        });
      }

      var currIndex = calcChildren.findIndex(function (o) {
        return o.props.value === _this.state.selectedItemValue;
      });

      if (currIndex >= _this.props.defaultPageSize && !open) {
        _this.setState({
          virtualStart: currIndex - _this.props.defaultPageSize
        });
      }

      return calcChildren.slice(virtualStart, virtualStart + defaultPageSize * 3);
    });

    var _this$props8 = _this.props,
        _open = _this$props8.open,
        _value = _this$props8.value;
    _this.focusableItems = [];
    _this.state = {
      open: _open,
      // selectedItem state initialization is handled in React lifecycle methods
      selectedItemIndex: null,
      selectedItemText: '',
      selectedItemValue: _value,
      selectedItemIconName: '',
      focusedItemIndex: -1,
      searchedText: {
        value: '',
        show: false
      },
      virtualStart: 0
    };
    _this.dropdownPanelRef = React.createRef();

    var nRowHeight = _this.getRowHeightNum();

    _this.virtualScrollDropdownHeight = props.virtualScrollDropdownHeight ? props.virtualScrollDropdownHeight : props.defaultPageSize * nRowHeight;
    return _this;
  }

  _createClass(WebDropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var value = this.props.value;
      this.focusableItems = this.dropdown.querySelectorAll(focusableItemRoles);

      if (value) {
        var selectedItemNode = this.selectItemFromProps();

        if (selectedItemNode) {
          var selectedProps = selectedItemNode.props;
          this.setState({
            selectedItemText: selectedProps.itemText,
            selectedItemIndex: selectedItemNode.index,
            selectedItemValue: selectedProps.value,
            selectedItemIconName: selectedProps.iconName,
            iconType: selectedProps.iconType
          });
        } else {
          this.setState({
            selectedItemText: '',
            selectedItemIndex: null,
            selectedItemValue: null
          });
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _this$props9 = this.props,
          value = _this$props9.value,
          virtualScroll = _this$props9.virtualScroll,
          defaultPageSize = _this$props9.defaultPageSize;
      /* scroll bar position calculation */

      if (!prevState.open && this.state.open && value && virtualScroll) {
        var calcChildren = this.getCalcChildren();
        var scrollPxAmount = (defaultPageSize + 1) * this.getRowHeightNum();

        if (calcChildren) {
          var currIndex = calcChildren.findIndex(function (o) {
            return o.props.value === _this2.state.selectedItemValue;
          });

          if (currIndex <= defaultPageSize - 1) {
            scrollPxAmount = currIndex * this.getRowHeightNum();
          }

          if (this.dropdownPanelRef) {
            this.dropdownPanelRef.current.scrollTop = scrollPxAmount;
          }
        }
      }
      /* the DropdownItem list can be changed after render, ie by the app or searchable */


      this.focusableItems = this.dropdown.querySelectorAll(focusableItemRoles);
      /* TDA-14247+Linked Issue - Add ability to change/reset a dropdown component after initialization */

      if (prevProps.value !== value) {
        var selectedItemNode = this.selectItemFromProps();

        if (selectedItemNode) {
          var selectedProps = selectedItemNode.props; // eslint-disable-next-line react/no-did-update-set-state

          this.setState({
            selectedItemText: selectedProps.itemText,
            selectedItemIndex: selectedItemNode.index,
            selectedItemValue: selectedProps.value,
            selectedItemIconName: selectedProps.iconName,
            iconType: selectedProps.iconType
          });
        } else {
          // eslint-disable-next-line react/no-did-update-set-state
          this.setState({
            selectedItemText: '',
            selectedItemIndex: null,
            selectedItemValue: null
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props10 = this.props,
          alignRight = _this$props10.alignRight,
          buttonIcon = _this$props10.buttonIcon,
          buttonKind = _this$props10.buttonKind,
          buttonAriaLabel = _this$props10.buttonAriaLabel,
          className = _this$props10.className,
          defaultText = _this$props10.defaultText,
          description = _this$props10.description,
          disabled = _this$props10.disabled,
          dropdownKind = _this$props10.dropdownKind,
          dropUp = _this$props10.dropUp,
          dynamicDropAlign = _this$props10.dynamicDropAlign,
          dynamicDropDirection = _this$props10.dynamicDropDirection,
          error = _this$props10.error,
          fieldID = _this$props10.fieldID,
          iconNameClose = _this$props10.iconNameClose,
          iconNameOpen = _this$props10.iconNameOpen,
          inlineLabel = _this$props10.inlineLabel,
          label = _this$props10.label,
          labelWidth = _this$props10.labelWidth,
          panelHeight = _this$props10.panelHeight,
          panelWidth = _this$props10.panelWidth,
          required = _this$props10.required,
          optional = _this$props10.optional,
          searchable = _this$props10.searchable,
          size = _this$props10.size,
          virtualScroll = _this$props10.virtualScroll,
          defaultPageSize = _this$props10.defaultPageSize,
          removeMarginTop = _this$props10.removeMarginTop,
          onChange = _this$props10.onChange,
          other = _objectWithoutProperties(_this$props10, _excluded);

      var _this$state4 = this.state,
          open = _this$state4.open,
          searchedText = _this$state4.searchedText,
          selectedItemIndex = _this$state4.selectedItemIndex,
          selectedItemText = _this$state4.selectedItemText,
          selectedItemValue = _this$state4.selectedItemValue,
          selectedItemIconName = _this$state4.selectedItemIconName,
          virtualStart = _this$state4.virtualStart,
          iconType = _this$state4.iconType;
      var calcChildrenActual;
      var calcChildren = this.getCalcChildren();

      if (virtualScroll && calcChildren) {
        calcChildrenActual = this.getActualChildren(calcChildren);
      } else {
        calcChildrenActual = calcChildren;
      }

      var currentIcon;

      if (!dropUp && open) {
        currentIcon = iconNameClose;
      } else if (!dropUp || open) {
        currentIcon = iconNameOpen;
      } else {
        currentIcon = iconNameClose;
      }

      var validDivProps = getValidElementProps('div', _objectSpread({}, other));
      var dropdownClasses = classNames(_defineProperty({
        dropdown: true,
        'maxwidth-100p': true
      }, className, className));
      var dropdownLabelClasses = classNames({
        dropdown__label: true,
        'position-absolute': dropdownKind === 'select',
        'maxwidth-100p': true,
        'paddingright-xl': dropdownKind === 'select',
        'paddingleft-lg': dropdownKind === 'select',
        'textalign-left': true
      });
      var comboboxProps = {
        'aria-owns': "".concat(fieldID, "-listbox"),
        'aria-controls': "".concat(fieldID, "-listbox"),
        'aria-autocomplete': 'list',
        role: 'combobox',
        'aria-label': label,
        'aria-activedescendant': selectedItemIndex !== null ? "".concat(fieldID, "-listitem-").concat(selectedItemIndex) : null,
        onChangeValue: function onChangeValue(e) {
          return _this3.onSearchType(e);
        }
      };
      return /*#__PURE__*/React.createElement(KeyListener, {
        onTab: this.close,
        onSftTab: this.close,
        onEsc: this.close,
        onUp: this.onUpArrow,
        onDown: this.onDownArrow
      }, /*#__PURE__*/React.createElement(ClickListener, {
        onClickOutside: this.close
      }, /*#__PURE__*/React.createElement("div", _extends({}, validDivProps, {
        value: selectedItemValue,
        className: dropdownClasses,
        role: "presentation",
        ref: function ref(_ref2) {
          _this3.dropdown = _ref2;
        },
        style: {
          width: dropdownKind === 'menu' ? 'auto' : labelWidth
        }
      }), dropdownKind === 'menu' ? /*#__PURE__*/React.createElement(Button, {
        kind: buttonKind,
        size: size,
        icon: buttonIcon,
        iconName: currentIcon,
        onClick: this.toggle,
        disabled: disabled,
        "aria-haspopup": "listbox",
        "aria-expanded": open,
        "aria-label": buttonAriaLabel
      }, /*#__PURE__*/React.createElement("div", {
        className: dropdownLabelClasses
      }, defaultText)) : /*#__PURE__*/React.createElement(DropdownField, _extends({
        name: "".concat(fieldID, "-DropdownField"),
        fieldID: "".concat(fieldID, "-DropdownField"),
        label: label,
        error: error,
        description: description,
        inlineLabel: inlineLabel,
        required: required,
        optional: !required && optional,
        onClick: this.handleClick,
        onKeyDown: this.handleKeyDown,
        size: size,
        placeholder: selectedItemText === '' || selectedItemText === null ? defaultText : selectedItemText,
        onFocus: this.dropdownPanelFocus,
        onBlur: this.dropdownPanelBlur,
        value: searchedText.show ? searchedText.value : selectedItemText,
        disabled: disabled,
        "aria-haspopup": "listbox",
        isExpanded: open,
        searchable: searchable,
        inlineIconName: selectedItemIconName,
        iconType: iconType,
        iconName: currentIcon,
        removeMarginTop: removeMarginTop
      }, searchable && comboboxProps)), /*#__PURE__*/React.createElement("div", {
        className: classNames({
          'position-relative': true,
          'width-100p': true
        }),
        style: {
          marginTop: dropdownKind === 'select' && (description || error) ? '-22px' : 0
        }
      }, /*#__PURE__*/React.createElement(DropdownPanel, {
        isOpen: open,
        width: panelWidth,
        alignRight: alignRight,
        dropUp: dropUp,
        dynamicDropAlign: dynamicDropAlign,
        dynamicDropDirection: dynamicDropDirection,
        fieldSize: size,
        height: virtualScroll ? this.virtualScrollDropdownHeight : panelHeight,
        dropdownPanelRef: this.dropdownPanelRef
      }, /*#__PURE__*/React.createElement("ul", _extends({
        role: dropdownKind === 'select' ? 'listbox' : 'menu'
      }, dropdownKind === 'select' && _defineProperty({
        id: "".concat(fieldID, "-listbox")
      }, 'aria-labelledby', "".concat(fieldID, "-DropdownField")), {
        onFocus: this.dropdownPanelFocus,
        onBlur: this.dropdownPanelBlur
      }), (virtualScroll ? showWaypointUp(virtualStart, virtualScroll) : false) && /*#__PURE__*/React.createElement(Waypoint, {
        onEnter: this.handleLoadDataUp
      }), calcChildrenActual && calcChildrenActual.length > 0 ? calcChildrenActual : 'No results found', (virtualScroll ? showWaypoint(virtualStart, calcChildren.length, defaultPageSize, virtualScroll) : false) && /*#__PURE__*/React.createElement(Waypoint, {
        onEnter: this.handleLoadData
      })))))));
    }
  }]);

  return WebDropdown;
}(PureComponent);

_defineProperty(WebDropdown, "propTypes", {
  /** ID for dropdown input field */
  fieldID: PropTypes.string,

  /** All direct descendent Elements or Components passed within the Dropdown Component (ie DropdownItem, DropdownGroup) */
  children: PropTypes.node,

  /** Classes to apply to the Dropdown Component */
  className: PropTypes.string,

  /** Default text of the Dropdown */
  defaultText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Match this 'value' prop to one of the DropdownItems' 'value' prop to select that item */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** indicates dropdown kind - 'select' or 'menu' behavior and accessibility roles */
  dropdownKind: PropTypes.oneOf(['select', 'menu']),

  /** Callback function on input type (event) or when dropdown item is selected (selectedItem info) */
  onChange: PropTypes.func,

  /** Toggle the state of the ItemList panel */
  open: PropTypes.bool,

  /** icon name for opening the dropdown */
  iconNameOpen: PropTypes.string,

  /** icon name for closing the dropdown */
  iconNameClose: PropTypes.string,

  /** Toggle disabled state of the Dropdown */
  disabled: PropTypes.bool,

  /** size of the button/input field element */
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /** For 'dropdownKind="menu"' - Button style of the field element */
  buttonKind: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'borderless']),

  /** indicates whether the button should have an icon on left, right, none, or only if it's just an icon button without text. Must also pass `iconName` */
  buttonIcon: PropTypes.oneOf(['right', 'left', 'none', 'only']),

  /** aria-label for menu button, used when menu button is icon only */
  buttonAriaLabel: PropTypes.string,

  /** custom dropdown label width. Default is 100% */
  labelWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** custom dropdown panel width. Default is 100% on dropdownKind 'select'. Enter width number for dropdownKind 'menu' (suggested width: 240px) */
  panelWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** set dropdown panel height to allow vertical scrolling. Default is auto. */
  panelHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** indicates if you want to have the dropdown panel to align right */
  alignRight: PropTypes.bool,

  /** indicates if you want to have the dropdown panel to open up */
  dropUp: PropTypes.bool,

  /** indicates if the dropdown should should open in the opposite direction (up or down) when it would otherwise go over the edge of the page */
  dynamicDropDirection: PropTypes.bool,

  /** indicates if the dropdown should align with the opposite side of its value field when it would otherwise go over the edge of the page */
  dynamicDropAlign: PropTypes.bool,

  /** indicates whether the dropdown should be a combo box with search type-ahead  */
  searchable: PropTypes.bool,

  /** Add label for Dropdown select field */
  label: PropTypes.string,

  /** Display dropdown select label inside the field */
  inlineLabel: PropTypes.bool,

  /** Add description for Dropdown select field */
  description: PropTypes.string,

  /** Add error description for Dropdown select field */
  error: PropTypes.string,

  /** Set true if field is required */
  required: PropTypes.bool,

  /** Display optional next to the label */
  optional: PropTypes.bool,

  /** Set to true to have virtual/infinite scrolling without pagination */
  virtualScroll: PropTypes.bool,

  /** Make virtualScroll table a fixed height with a fixed header. You can put string ("500px") or number {500}  */
  virtualScrollDropdownHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Number of rows of data by default */
  defaultPageSize: PropTypes.number,

  /** Remove margin top above the input label */
  removeMarginTop: PropTypes.bool,

  /** Custom filter for searched text */
  customSearchFilter: PropTypes.func
});

_defineProperty(WebDropdown, "defaultProps", {
  open: false,
  disabled: false,
  iconNameOpen: 'arrow_drop_down',
  iconNameClose: 'arrow_drop_up',
  onChange: function onChange() {},
  alignRight: false,
  dropUp: false,
  dynamicDropDirection: false,
  dynamicDropAlign: false,
  buttonKind: 'secondary',
  buttonIcon: 'right',
  value: null,
  dropdownKind: 'select',
  labelWidth: '100%',
  panelWidth: '100%',
  panelHeight: 'auto',
  searchable: false,
  required: false,
  defaultPageSize: 15,
  customSearchFilter: function customSearchFilter(itemText, searchText) {
    return itemText.toLowerCase().includes(searchText.toLowerCase());
  }
});

export { WebDropdown as default };
WebDropdown.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "selectItemFromProps",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onUpArrow",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onDownArrow",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onSearchType",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "findGroupedItemValueMatch",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "group",
      "type": null
    }, {
      "name": "groupIndex",
      "type": null
    }],
    "returns": null
  }, {
    "name": "findItemValueMatch",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "item",
      "type": null
    }, {
      "name": "itemIndex",
      "type": null
    }],
    "returns": null
  }, {
    "name": "iterateDropdownFocus",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "focusIndex",
      "type": null
    }],
    "returns": null
  }, {
    "name": "close",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "toggle",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "evt",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleItemSelected",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "info",
      "type": null
    }, {
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "returnFocus",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "buildDropdownGroup",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "group",
      "type": null
    }, {
      "name": "index",
      "type": null
    }],
    "returns": null
  }, {
    "name": "buildDropdownItem",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "child",
      "type": null
    }, {
      "name": "index",
      "type": null
    }],
    "returns": null
  }, {
    "name": "buildMenuItem",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "child",
      "type": null
    }, {
      "name": "index",
      "type": null
    }],
    "returns": null
  }, {
    "name": "dropdownPanelFocus",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleClick",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleKeyDown",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "open",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "dropdownPanelBlur",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleLoadData",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleLoadDataUp",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }, {
    "name": "scroll",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "amount",
      "type": null
    }],
    "returns": null
  }, {
    "name": "getRowHeightNum",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "getCalcChildren",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "getActualChildren",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "calcChildren",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "WebDropdown",
  "props": {
    "open": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Toggle the state of the ItemList panel"
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Toggle disabled state of the Dropdown"
    },
    "iconNameOpen": {
      "defaultValue": {
        "value": "'arrow_drop_down'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "icon name for opening the dropdown"
    },
    "iconNameClose": {
      "defaultValue": {
        "value": "'arrow_drop_up'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "icon name for closing the dropdown"
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Callback function on input type (event) or when dropdown item is selected (selectedItem info)"
    },
    "alignRight": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicates if you want to have the dropdown panel to align right"
    },
    "dropUp": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicates if you want to have the dropdown panel to open up"
    },
    "dynamicDropDirection": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicates if the dropdown should should open in the opposite direction (up or down) when it would otherwise go over the edge of the page"
    },
    "dynamicDropAlign": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicates if the dropdown should align with the opposite side of its value field when it would otherwise go over the edge of the page"
    },
    "buttonKind": {
      "defaultValue": {
        "value": "'secondary'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'primary'",
          "computed": false
        }, {
          "value": "'secondary'",
          "computed": false
        }, {
          "value": "'tertiary'",
          "computed": false
        }, {
          "value": "'borderless'",
          "computed": false
        }]
      },
      "required": false,
      "description": "For 'dropdownKind=\"menu\"' - Button style of the field element"
    },
    "buttonIcon": {
      "defaultValue": {
        "value": "'right'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'right'",
          "computed": false
        }, {
          "value": "'left'",
          "computed": false
        }, {
          "value": "'none'",
          "computed": false
        }, {
          "value": "'only'",
          "computed": false
        }]
      },
      "required": false,
      "description": "indicates whether the button should have an icon on left, right, none, or only if it's just an icon button without text. Must also pass `iconName`"
    },
    "value": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "Match this 'value' prop to one of the DropdownItems' 'value' prop to select that item"
    },
    "dropdownKind": {
      "defaultValue": {
        "value": "'select'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'select'",
          "computed": false
        }, {
          "value": "'menu'",
          "computed": false
        }]
      },
      "required": false,
      "description": "indicates dropdown kind - 'select' or 'menu' behavior and accessibility roles"
    },
    "labelWidth": {
      "defaultValue": {
        "value": "'100%'",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "custom dropdown label width. Default is 100%"
    },
    "panelWidth": {
      "defaultValue": {
        "value": "'100%'",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "custom dropdown panel width. Default is 100% on dropdownKind 'select'. Enter width number for dropdownKind 'menu' (suggested width: 240px)"
    },
    "panelHeight": {
      "defaultValue": {
        "value": "'auto'",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "set dropdown panel height to allow vertical scrolling. Default is auto."
    },
    "searchable": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicates whether the dropdown should be a combo box with search type-ahead"
    },
    "required": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Set true if field is required"
    },
    "defaultPageSize": {
      "defaultValue": {
        "value": "15",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Number of rows of data by default"
    },
    "customSearchFilter": {
      "defaultValue": {
        "value": "(itemText, searchText) => itemText.toLowerCase().includes(searchText.toLowerCase())",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Custom filter for searched text"
    },
    "fieldID": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "ID for dropdown input field"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "All direct descendent Elements or Components passed within the Dropdown Component (ie DropdownItem, DropdownGroup)"
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Classes to apply to the Dropdown Component"
    },
    "defaultText": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "Default text of the Dropdown"
    },
    "size": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'small'",
          "computed": false
        }, {
          "value": "'medium'",
          "computed": false
        }, {
          "value": "'large'",
          "computed": false
        }]
      },
      "required": false,
      "description": "size of the button/input field element"
    },
    "buttonAriaLabel": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "aria-label for menu button, used when menu button is icon only"
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Add label for Dropdown select field"
    },
    "inlineLabel": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Display dropdown select label inside the field"
    },
    "description": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Add description for Dropdown select field"
    },
    "error": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Add error description for Dropdown select field"
    },
    "optional": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Display optional next to the label"
    },
    "virtualScroll": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Set to true to have virtual/infinite scrolling without pagination"
    },
    "virtualScrollDropdownHeight": {
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": "Make virtualScroll table a fixed height with a fixed header. You can put string (\"500px\") or number {500}"
    },
    "removeMarginTop": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Remove margin top above the input label"
    }
  }
};